export default defineNuxtRouteMiddleware((to) => {
    const publicPaths = ['/', '/thankyou']
    if (publicPaths.includes(to.path) || to.path.startsWith('/auth')) {
        return
    }

    const accessToken = useCookie<string | null>('access_token')

    if (!accessToken.value) {
        return navigateTo('/auth/login')
    }
})
